import styled from '@emotion/styled';
import { fontSizes, colors, spacing } from 'ui_system/compass/utils';
import { ArrowDropDown } from 'views/ui/icons';

export const SelectStyles = {
  container: (base: any) => ({
    ...base,
    fontFamily: 'inherit',
    fontSize: fontSizes.medium,
    padding: '0',
  }),
  control: (base: any) => ({
    ...base,
    boxShadow: 'none',
    border: `1px solid ${colors.borderAction}`,
    borderRadius: 'none',
    height: '44px',
    '&:hover': {
      border: `1px solid ${colors.borderAction}`,
    },
    '&::after': {
      boxShadow: `0px 0px 10px 0px ${colors.borderAction}`,
      clipPath: 'inset(-100% 0px 0px)',
    },
  }),
  indicatorsContainer: () => ({
    paddingRight: '8px',
  }),
  menu: (base: any) => ({
    ...base,
    background: colors.white,
    border: `1px solid ${colors.borderAction}`,
    borderRadius: 'none',
    borderTop: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    margin: 0,
  }),
  menuList: (base: any) => ({
    ...base,
    maxHeight: '367px',
    overflowY: 'auto',
    scrollbarColor: `${colors.border} ${colors.white}`,
    scrollbarWidth: 'thin',
    padding: '0',
  }),
  option: (base: any, state: any) => ({
    ...base,
    background: `${
      state?.isSelected ? state?.selectProps?.brandColor : colors.white
    }`,
    boxShadow: `inset 0 1px 0 ${colors.background.light}`,
    boxSizing: 'border-box',
    color: `${state?.isSelected ? colors.white : colors.text.primary}`,
    cursor: 'pointer',
    fontSize: fontSizes.medium,
    fontWeight: '400',
    paddingLeft: spacing.medium,
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    height: '44px',
    '&:active': {
      background: colors.background.active,
      boxShadow: 'none',
    },
    '&:hover': {
      color: `${colors.white}`,
      background:
        `${state?.selectProps?.brandColor}` || colors.background.active,
      boxShadow: 'none',
    },
  }),
  placeholder: (base: any) => ({
    ...base,
    color: colors.text.primary,
    left: '16px',
    top: '12px',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: colors.text.primary,
    left: '16px',
    top: '12px',
  }),
};

export const ArrowDropDownIcon = styled(ArrowDropDown)`
  flex-shrink: 0;
  margin-left: ${spacing.medium};
`;
